module.exports = __webpack_public_path__ + "static/media/Aparna_Iyer_S21.7b9b5183.png";